export default __webpack_public_path__ + "catalogue.1ac122e2.svg";